// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2ZKZa","title":"ClientInsurance_title__O0O7A","itemText":"ClientInsurance_itemText__3AwCK"};